import React from 'react';
import { Container, Typography, Box, Paper, Grid, Card, CardContent, Avatar } from '@mui/material';

const Faculty = () => {
  // Explicit faculty objects to be populated manually with name and college
  const facultyMembers = [
    { photo: 'rath.jpeg', name: 'Dr G. K. Rath', college: 'AIIMS, New Delhi' },
    { photo: 'anand.jpeg', name: 'Dr A. K. Anand', college: 'Fortis, Gurgaon' },
    { photo: 'pamela.jpeg', name: 'Dr Pamela Jeyaraj', college: 'CMC, Ludhiana' },
    { photo: 'jaineet.jpeg', name: 'Dr Jaineet Sachdeva', college: 'CMC, Ludhiana' },
    { photo: 'abraham.jpeg', name: 'Dr. Abraham P. Abraham', college: 'CMC, Ludhiana' },
    { photo: 'mary.jpeg', name: 'Dr Mary Joan', college: 'CMC, Ludhiana' },
    { photo: 'daya.jpeg', name: 'Dr Dayapreet Kaur', college: 'DMC, Ludhiana' },
    { photo: 'abhidha.jpeg', name: 'Dr Abhidha Malik', college: 'AIIMS, New Delhi' },
    { photo: 'aman_sharma.jpeg', name: 'Dr Aman Sharma', college: 'IGMC, Shimla' },  
    { photo: 'anil.jpeg', name: 'Dr Anil Kumar Goyal', college: 'AIIMS, Bathinda' },
    { photo: 'archana.jpeg', name: 'Dr Archana Dutta', college: 'PIMS, Jalandhar' },
    { photo: 'arun.jpeg', name: 'Dr Arun K Agarwal', college: 'Aadhar Health Institute, Hisar' },
    { photo: 'ashok_kumar.jpeg', name: 'Lt Col Dr Ashok Kumar', college: 'Sarvodhya Helathcare' },
    { photo: 'ashutosh.jpeg', name: 'Dr Ashutosh Gupta', college: 'GMC, Jammu' },
    { photo: 'bhavana.jpeg', name: 'Dr Bhavana Rai', college: 'PGIMER, Chandigarh' },
    { photo: 'bhide.jpeg', name: 'Dr Shreerang Bhide', college: 'Royal Marsden Hospital, UK' },
    { photo: 'budhi.jpeg', name: 'Dr Budhi Yadav', college: 'PGIMER, Chandigarh' },
    { photo: 'charu.jpeg', name: 'Dr Charu Garg', college: 'Max Saket, New Delhi' },
    { photo: 'deepak_gupta.jpeg', name: 'Dr Deepak Gupta', college: 'BMCHRC, Jaipur' },
    { photo: 'deepak.jpeg', name: 'Dr Deepak Abrol', college: 'AOI, Jammu' },
    { photo: 'devgan.jpeg', name: 'Dr R Devgan', college: 'GMC, Amritsar' },
    { photo: 'divya.jpeg', name: 'Dr Divya Khosla', college: 'PGIMER, Chandigarh' },
    { photo: 'gaurav_goel.jpeg', name: 'Dr Gaurav Goel', college: 'HCG Cancer Centre, Jaipur' },
    { photo: 'grewal.jpeg', name: 'Dr Gurvinder Singh Grewal', college: 'AOI, Ludhiana' },
    { photo: 'hanuman.jpeg', name: 'Dr Hanuman Yadav', college: 'ILBS, Delhi' },
    { photo: 'harpreet.jpeg', name: 'Dr Harpreet Singh', college: 'Mohandai Oswal Hospital, Ludhiana' },
    { photo: 'himanshu.jpeg', name: 'Dr Himanshu Srivastava', college: 'Capitol Hospital, Jalandhar' },
    { photo: 'indu.jpeg', name: 'Dr Indu Bansal', college: 'Paras Hospital, Gurgaon' },
    { photo: 'ishu.jpeg', name: 'Dr Ishu Sharma', college: 'Mohandai Oswal Hospital, Ludhiana' },
    { photo: 'jaskaran.jpeg', name: 'Dr Jaskaran S Sethi', college: 'RGCIRC, Delhi' },
    { photo: 'jaspinder.jpeg', name: 'Dr Jaspinder Kaur', college: 'CCA, Ludhiana' },
    { photo: 'kamlesh.jpeg', name: 'Dr Kamlesh Passi', college: 'Mohandai Oswal Hospital, Ludhiana' },
    { photo: 'kanika.jpeg', name: 'Dr Kanika Sood', college: 'Narayana Superspeciality Hospital, New Delhi' },
    { photo: 'kunal_jain.jpeg', name: 'Dr Kunal Jain', college: 'AOI, Ludhiana' },
    { photo: 'kundal.jpeg', name: 'Dr Kundal Chufal', college: 'RGCI, New Delhi' },
    { photo: 'mahajan.jpeg', name: 'Dr M K Mahajan', college: 'CMC, Ludhiana' },
    { photo: 'manish_pandey.jpeg', name: 'Dr Manish Pandey', college: 'Max Hospital, Delhi' },
    { photo: 'manish.jpeg', name: 'Dr Manish Gupta', college: 'IGMC, Shimla' },
    { photo: 'manishi.jpeg', name: 'Dr Manishi Bansal', college: 'Fortis Hospital, Mohali' },
    { photo: 'manjinder.jpeg', name: 'Dr Manjinder Singh Sidhu', college: 'DMC, Ludhiana' },
    { photo: 'maqbool.jpeg', name: 'Dr Maqbool Lane', college: '' },
    { photo: 'meena.jpeg', name: 'Dr Meena Sudan', college: 'SGRDIMSR, Amritsar' },
    { photo: 'meenakshi.jpeg', name: 'Dr Meenakshi Mittal', college: 'Livasa Hospital, Mohali' },
    { photo: 'mohit.jpeg', name: 'Dr Mohit Tyagi', college: '' },
    { photo: 'munish.jpeg', name: 'Dr Munish Gairola', college: 'RGCIRC, Delhi' },
    { photo: 'narendra.jpeg', name: 'Dr Narendra Bhalla', college: 'Fortis Hospital, Mohali' },
    { photo: 'neeraj.jpeg', name: 'Dr Neeraj Jain', college: 'SGRDIMSR, Amritsar' },
    { photo: 'nidhi.jpeg', name: 'Dr Nidhi Gupta', college: 'GMC, Chandigarh' },
    { photo: 'nitin.jpeg', name: 'Dr Nitin Peters', college: 'PGIMER, Chandigarh' },
    { photo: 'pankaj.jpeg', name: 'Dr Pankaj K Arora', college: 'Max Hospital, Mohali' },
    { photo: 'paramjit.jpeg', name: 'Dr Raja Paramjeet Singh', college: 'GMC, Patiala' },
    { photo: 'parneet.jpeg', name: 'Dr Parneet Singh', college: 'Livasa Hospital, Mohali' },
    { photo: 'parveen.jpeg', name: 'Dr Parveen Kaur', college: 'Fortis Hospital, Ludhiana' },
    { photo: 'pradeep.jpeg', name: 'Dr Pradeep Garg', college: 'GGS, Faridkot' },
    { photo: 'preeti.jpeg', name: 'Dr Preety Negi', college: 'Capitol Hospital, Jalandhar' },
    { photo: 'purnima.jpeg', name: 'Dr Purnima Thakur', college: 'IGMC, Shimla' },
    { photo: 'rajeev.jpeg', name: 'Dr Rajeev Attri', college: 'Regional Cancer Centre, Rohtak' },
    { photo: 'rajesh.jpeg', name: 'Dr Rajesh Pasricha', college: 'AIIMS, Bhopal' },
    { photo: 'rakesh.jpeg', name: 'Dr Rakesh Kapoor', college: 'PGIMER, Chandigarh' },
    { photo: 'raman.jpeg', name: 'Dr Raman Arora', college: 'CMC, Ludhiana' },
    { photo: 'renu.jpeg', name: 'Dr Renu Madhan', college: 'Venkateshwar Hospital, Delhi' },
    { photo: 'ritu.jpeg', name: 'Dr Ritu Agarwal', college: 'AOI, Ludhiana' },
    { photo: 'romikant.jpeg', name: 'Dr Romikant Grover', college: 'GGS, Faridkot' },
    { photo: 's_chawla.jpeg', name: 'Dr Shikha Chawla', college: 'Patel Hospital, Jalandhar' },
    { photo: 'sajal.jpeg', name: 'Dr Sajal Kakkar', college: 'Max Hospital, Mohali' },
    { photo: 'sandhya.jpeg', name: 'Dr Sandhya Sood', college: 'AOI, Ludhiana' },
    { photo: 'sapna.jpeg', name: 'Dr Sapna Marcus', college: 'AIIMS Bathinda' },
    { photo: 'sarthak.jpeg', name: 'Dr Sarthak Tandon', college: 'RGCIRC, Delhi' },
    { photo: 'shabab.jpeg', name: 'Dr Shabab L Angurana', college: 'AIIMS, Jammu' },
    { photo: 'shamit.jpeg', name: 'Dr Shamit Chopra', college: 'Patel Hospital, Jalandhar' },
    { photo: 'sharmaji.jpeg', name: 'Dr D N Sharma', college: 'AIIMS, Rewari and Bilaspur' },
    { photo: 'shelley.jpeg', name: 'Dr Shelley Hukku', college: 'Sir Ganga Ram Hospital, New Delhi' },
    { photo: 'shikha.jpeg', name: 'Dr Shikha Haldar', college: 'Sir Ganga Ram Hospital, New Delhi' },
    { photo: 'shruti.jpeg', name: 'Dr Shruti Kakkar', college: 'CMC, Ludhiana' },
    { photo: 'soumitra.jpeg', name: 'Dr Soumitra Barik', college: 'Bagchi Sri Shankara Cancer Centre and Research Institute, Bhubaneswar' },
    { photo: 'subhash.jpeg', name: 'Dr Subhash Singla', college: 'CMC, Ludhiana' },
    { photo: 'subramanyam.jpeg', name: 'Dr N Balasubramanian', college: '' },
    { photo: 'supriya.jpeg', name: 'Dr Supriya Mallick', college: 'AIIMS, New Delhi' },
    { photo: 'sushmita.jpeg', name: 'Dr Sushmita Goshal', college: 'PGIMER, Chandigarh' },
    { photo: 'tapas.jpeg', name: 'Dr Tapas Dora', college: 'HBCH, Sangrur' },
    { photo: 'tejinder.jpeg', name: 'De Tejinder Kataria', college: 'Medanta Gurgaon' },
    { photo: 'vaithee.jpeg', name: 'Dr R Vaitheeswaran', college: 'Elekta India' },
    { photo: 'vinod_d.jpeg', name: 'Dr Vinod Dangwal', college: 'GMC, Patiala' },
    { photo: 'vinod.jpeg', name: 'Dr Vinod Nimbran', college: 'Indus Superspeciality Hospital, Mohali' },
    { photo: 'vipul.jpeg', name: 'Dr Vipul Nautiyal', college: 'Himalayan Hospital, Dehradun' },
    { photo: 'virender.jpeg', name: 'Col Dr Virender Suhag', college: 'Army Hospital, Delhi' },
    { photo: 'vivek.jpeg', name: 'Dr Vivek Immanual', college: 'Fortis Memorial Research Institute' },
    { photo: 'yashpal.jpeg', name: 'Dr Yashpal Verma', college: 'Atal Cancer Care Centre, Ambala' },
    { photo: 'arun_chougale.jpeg', name: 'Dr Arun Chougule', college: 'SMS College, Jaipur' },
    { photo: 'manjit.jpeg', name: 'Dr Manjit Jaura', college: 'Pragma Medical Institute, Bathinda' },
    { name: 'Dr Shikha Goyal', college: 'PGIMER, Chandigarh' },
    { name: 'Dr Kislay Dimri', college: 'GMCH, Chandigarh' },
    { name: 'Dr Nahida Yousuf', college: 'GMC, Srinagar' },
    { name: 'Mr. A. R. Arputharaj', college: '' },
    { name: 'Mr. Rajesh Chandran', college: '' },
    { name: 'Dr Shailesh Shinde', college: '' },
    { name: 'Dr V. K. Dangwal', college: '' },
    { name: 'Dr Manraj Singh Kang', college: '' },
    { name: 'Dr Karuna Singh', college: '' },
  ];

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Paper elevation={0} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Faculty Members
          </Typography>
          
          <Typography variant="subtitle1" paragraph>
            Meet our distinguished faculty members who are organizing and participating in the conference
          </Typography>

          <Grid container spacing={3}>
            {facultyMembers.map((member, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <Card elevation={0} sx={{ height: '100%', backgroundColor: '#f8f9fa' }}>
                  <CardContent sx={{ textAlign: 'center', p: 2 }}>
                    <Avatar
                      src={`/assets/faculty/${member.photo}`}
                      alt={member.name || `Faculty member ${index + 1}`}
                      sx={{ width: 120, height: 120, mx: 'auto', mb: 2 }}
                    />
                    <Typography variant="h6" component="h3" gutterBottom>
                      {member.name?.trim() || '[Name]'}
                    </Typography>
                    {member.college?.trim() ? (
                      <Typography variant="body2" color="text.secondary">
                        {member.college}
                      </Typography>
                    ) : null}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Box>
    </Container>
  );
};

export default Faculty; 